<template>
    <div class="animated fadeIn">
  
      
      <b-card class="card-accent-info" header="Usuários">
        <b-card-body>
  
          <b-row>
            <b-col cols="auto" class="mr-auto">
              
            <b-form-group>
                  <b-button variant="outline-primary" :pressed.sync="tableSelectable">{{tableSelectable ? 'Desabilitar Seleção ' : 'Habilitar Seleção'}}</b-button>
                  &nbsp;
                  <b-button variant="outline-primary" v-show="tableSelectable" @click="selectAllRows">Selecionar todos</b-button>
                  &nbsp;
                  <b-button variant="outline-primary" v-show="tableSelectable" @click="clearSelectedRows">Limpar seleção</b-button>
            </b-form-group>
          
            </b-col>
            <b-col cols="auto" class="">
              <b-form-group>
                <b-button variant="vine" class="mr-1 btn-brand" @click="openBatchModal()"  v-show="tableSelectable"><i class="fa fa-toggle-on"></i><span>Alterar Selecionados</span></b-button>
                &nbsp;
                <b-button variant="github" class="mr-1 btn-brand" @click="openEditModal(null)"><i class="fa fa-plus"></i><span>Novo Usuário</span></b-button>
              </b-form-group>
            </b-col>
          </b-row>
              
  
         

          <b-row>
            <b-col cols="auto">
              <b-form-group>
                  <label for="company" style="font-size: 0.8em">Empresa</label>
                  <b-form-select id="company"
                    v-model="filters.companyId"
                    :plain="true"
                    :options="companyDDL"
                    @change="changeCompany"
                    :value="[null,'c']">
                  </b-form-select>
              </b-form-group>
            </b-col>

            <b-col cols="auto" >
              <b-form-group>
                  <label for="filter" style="font-size: 0.8em">Localizar</label>
                  <b-form-input v-model="filters.key" type="text" id="filter" placeholder="Localizar"  v-on:keyup.enter="filterChanged"></b-form-input>
              </b-form-group>
            </b-col>
            
            
            <b-col cols="auto" >
              <b-form-group>
                  <label for="department" style="font-size: 0.8em">Grupo</label>
                  <b-form-select id="group"
                    v-model="filters.groupId"
                    :plain="true"
                    :options="selectGroupDDL"
                    >
                  </b-form-select>
              </b-form-group>
            </b-col>
          
          <!--
          <b-col cols="auto">
              <b-form-group>
                  <label for="departmentId" style="font-size: 0.8em">Departamento</label>
                  <b-form-select id="departmentId"
                    v-model="filters.departmentId"
                    :plain="true"
                    :options="selectDepartmentDDL">
                  </b-form-select>
              </b-form-group>
            </b-col>

            <b-col cols="auto">
              <b-form-group>
                  <label for="status" style="font-size: 0.8em">Cargo/Função</label>
                  <b-form-select id="jobPositionId"
                    v-model="filters.jobPositionId"
                    :plain="true"
                    :options="selectJobPositionDDL">
                  </b-form-select>
              </b-form-group>
            </b-col>
            -->

            <b-col cols="auto">
              <b-form-group>
                  <label for="status" style="font-size: 0.8em">Ativo/Inativo</label>
                  <b-form-select id="status"
                    v-model="filters.status"
                    :plain="true"
                    :options="statusddl">
                  </b-form-select>
              </b-form-group>
            </b-col>

            <b-col cols="auto" class="mr-auto" style="padding-top: 12px;">
              <b-form-group>
                <p></p>
                <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="refreshData()"><i class="fa fa-search"></i><span>Localizar</span></b-button>
              </b-form-group>
            </b-col>

            

            <b-col cols="auto" class="">
              <b-form-group >
                  <label for="perPage" style="font-size: 0.8em">Linhas</label>
                  <b-form-select v-model="perPage" id="perPage"
                    :plain="true"
                    :options="[5,10,20,50,1000]">
                  </b-form-select>
                </b-form-group>
            </b-col>
            
          </b-row>
        
          <b-row class="mb-3">
            <b-col>
              <div class="d-flex align-items-center">
                <span class="text-muted">
                  <strong>Total:</strong> {{ items.length }} usuários
                  <span v-if="filteredItems.length !== items.length"> | <strong>Filtrados:</strong> {{ filteredItems.length }}</span>
                  <span v-if="selected.length > 0"> | <strong>Selecionados:</strong> {{ selected.length }}</span>
                </span>
                <b-spinner small variant="primary" class="ml-2" v-if="isLoadingMore"></b-spinner>
                <span v-if="isLoadingMore" class="text-primary ml-1" style="font-size: 0.9em">Carregando mais...</span>
              </div>
            </b-col>
          </b-row>

            <b-table
                :items="filteredItems"
                :fields="fields"
                :select-mode="selectMode"
                responsive="sm"
                ref="selectableTable"
                selectable
                @row-selected="onRowSelected"
                :primary-key="primaryKey"
                :tbody-transition-props="transProps"
                sort-icon-left
                @row-clicked="rowClicked"
                :per-page="perPage"
                :current-page="currentPage"
                :busy="isBusy"
                hover
                striped
                selected-variant="primary"
                >

                <template #table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Carregando...</strong>
                    </div>
                </template>
                
                <!-- Example scoped slot for select state illustrative purposes -->
                <template #cell(selected)="{ rowSelected }">
                    <template v-if="rowSelected">
                    <span aria-hidden="true">&check;</span>
                    <span class="sr-only">Selected</span>
                    </template>
                    <template v-else>
                    <span aria-hidden="true">&nbsp;</span>
                    <span class="sr-only">Not selected</span>
                    </template>
                </template>

                <template #cell(show_details)="row">
                    <b-row>
                        <b-col cols="auto" class="mr-auto">
                            <b-form-group>
                            <b-button size="sm" variant="dark"  @click="row.toggleDetails" class="mr-1 btn-brand"><i class="fa fa-search"></i></b-button>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </template>

                <template #row-details="row">
                 
                  <table>
                        <tr width='100%'>
                          <td><i>Apelido: </i></td>
                          <td style="min-width: 100px"><b>{{ row.item.alias }}</b></td>
                          <td><i>Departamento: </i></td>
                          <td style="min-width: 100px"><b>{{ row.item.departmentName }}</b></td>
                          <td><i>Cargo: </i></td>
                          <td style="min-width: 100px"><b>{{ row.item.jobPositionName }}</b></td>
                          <td><i>Nascimento: </i></td>
                          <td style="min-width: 100px"><b>{{ $utils.dateStringFormat(row.item.daten) }}</b></td>
                          <td width='100%'></td>
                        </tr>
                      </table>
                </template>
                
                <template v-slot:cell(avatar)="data">
                  <img v-if="hasCustomAvatar(data.item.avatar)" :src="(data.item.avatar.indexOf('/') > 0 ? '' : $store.state.currentUser.remotePath + $store.state.currentUser.avatarPath) + data.item.avatar" class="circle-img rounded-circle" />
                  <div v-else class="circle-img rounded-circle avatar-placeholder">{{ avatarInitial(data.item.name) }}</div>
                </template>
                
                   
                <template v-slot:cell(st)="data">
                    <c-switch class="" @change.native="changeStatusClick(data.item)" color="primary" :checked="data.item.st=='A'" label variant="pill" v-bind="switchLabelIcon" /> 
                </template>

                <template v-slot:cell(password)="data">
                  <b-button size="sm" variant="primary"  @click="changePasswordModal(data.item)" class="mr-1 btn-brand"><i class="fa fa-lock"></i></b-button>
                </template>
                
                <template v-slot:cell(name)="data">
                    <span class="text-brand-500">{{ data.item.username }}</span><br>
                    <span class="font-weight-bold">{{ data.item.name }}</span><br>
                    <span class="text-primary" v-if="data.item.email">{{ data.item.email }}<br></span>
                    <span class="text-muted" v-if="data.item.groups && data.item.groups.length > 0">Grupos: {{ data.item.groups && data.item.groups.length > 0 ? data.item.groups.map(g => g.name).sort().join(', ') : '' }} </span>
                </template>
                
            </b-table>
            <nav>
                <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" prev-text="Anterior" next-text="Próximo" />
            </nav>


        </b-card-body>
     </b-card>
  

         
     <b-modal
            v-model="passwordModal"
            id="password-modal"
            centered
            hide-footer
            :title="'Alterar Senha: ' + (this.changePasswordUser ? this.changePasswordUser.name : '')"
            size="lg">

            <b-form @submit.stop.prevent="onSubmit">

              <div class="animated fadeIn">
    
    
    <b-row>
      <b-col md="12">
        
          <b-form>
            <b-form-group
            :description="'Entre com a senha do usuário ' + this.$store.state.currentUser.username"
            label="Senha atual"
            label-for="currentpassword"
            :label-cols="3"
            :horizontal="true">
            <b-form-input v-model="currentPassword" id="currentpassword" type="password"></b-form-input>
          </b-form-group>          
          </b-form>
          </b-col>
          </b-row>

          <b-row>
      <b-col md="12">
        
          <b-form>
            <b-form-group
            description="Entre com a nova senha"
            label="Nova senha"
            label-for="password"
            :label-cols="3"
            :horizontal="true">
            <b-form-input v-model="password" id="password" type="password"></b-form-input>
          </b-form-group>          
          </b-form>
          </b-col>
          </b-row>

          <b-row>
      <b-col md="12">
        
          <b-form>
            <b-form-group
            description=""
            label="Confirmar senha"
            label-for="password2"
            :label-cols="3"
            :horizontal="true">
            <b-form-input v-model="password2" id="password2" type="password"></b-form-input>
          </b-form-group>          
          </b-form>
          </b-col>
          </b-row>

          <b-input-group class="mb-4">
                    <div class="text-danger" v-if="this.changePasswordErrorMessage && this.changePasswordErrorMessage != ''"><i class="fa fa-exclamation-triangle fa-lg mt-4"></i> {{ this.changePasswordErrorMessage }}</div>
                  </b-input-group>


          </div>
          
          <div slot="footer" class="text-right">
            <b-button variant="primary" @click="changePassword()"><i class="fa fa-check"></i> Alterar Senha</b-button>
          </div>
               
            </b-form>

        </b-modal>


     <b-modal
              header-bg-variant="none"
              v-model="dangerModal"
              id="modal-danger"
              centered
              hide-footer
              title="Alterar Selecionados"
              size="lg">

        <b-form @submit.stop.prevent="onSubmit">
        <div class="animated fadeIn">
          <b-card>
            
            <b-form-group
              description=""
              label="Selecionados"
              label-for="batch-count"
              :label-cols="3"
              :horizontal="true">
              <b-row>
                <b-col cols="4" style="padding-top: 7px">
                  {{  selected.length }}
                </b-col>
              </b-row>
            </b-form-group>

            <hr>

            <b-form-group
              description=""
              label="Grupos de Acesso"
              label-for="batch-count-action"
              :label-cols="3"
              :horizontal="true">
                <b-form-select id="groupAction"
                  v-model="batchItem.groupAction"
                  :plain="true"
                  :options="groupActionDDL" style="width: 200px;">
                </b-form-select>
            </b-form-group>


            <b-form-group
              description=""
              label=""
              label-for=""
              :label-cols="3"
              :horizontal="true">
              <!--
              <multiselect v-model="selectedGroups" :options="groupddl" :multiple="true" label="label" track-by="label"></multiselect>
              -->
              <v-select v-model="batchGroups" multiple :options="groupDDL" placeholder="Selecionar grupos" label="text"></v-select>
            </b-form-group>
            
            <b-form-group
              description=""
              label="Status"
              label-for=""
              :label-cols="3"
              :horizontal="true">                
                <b-form-select id="status"
                  v-model="batchItem.status"
                  :plain="true"
                  :options="batchStatusDDL">
                </b-form-select>
            </b-form-group>

            <hr>
          
            <b-form-group
              description=""
              label="Senha"
              label-for="password"
              :label-cols="3"
              :horizontal="true">
              <b-form-input  v-model="batchItem.password" id="password" type="password" autocomplete="password" placeholder="Senha" required></b-form-input>
            </b-form-group>    

            <b-form-group
              description=""
              label="Confirmar senha"
              label-for="password2"
              :label-cols="3"
              :horizontal="true">
              <b-form-input  v-model="batchItem.password2" id="password2" type="password" autocomplete="password2" placeholder="Confirmar senha" required></b-form-input>
            </b-form-group>

            <div class="text-danger" v-if="this.batchErrorMessage && this.batchErrorMessage != ''"><i class="fa fa-exclamation-triangle fa-lg mt-4"></i> {{ this.batchErrorMessage }}</div>
            
            <div slot="footer" class="text-right">
              <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="closeDangerModal()"><i class="fa fa-window-close"></i><span>Cancelar</span></b-button>
              <b-button variant="github" class="mr-1 btn-brand" @click="changeBatch()"><i class="fa fa-check"></i><span>Alterar Selecionados</span></b-button>
            
            </div>


          </b-card>
        </div>
      </b-form>
      
    </b-modal>
  



    <!-- header-bg-primary="primary" -->
     <b-modal
     header-bg-variant="none"
              v-model="editModal"
              id="edit-modal"
              centered
              hide-footer
              title="Usuário"
              size="lg">
  

        <b-nav fill>
            <b-nav-item :active="tabInfo=='U'" @click="tabInfo='U'">Usuário</b-nav-item>
            <b-nav-item :active="tabInfo=='G'" @click="tabInfo='G'">Grupos de Acesso</b-nav-item>
        </b-nav>

        <div v-show="tabInfo == 'G'">
          <b-card>
              <b-form-group
                description=""
                label="Grupos de Acesso"
                label-for=""
                :label-cols="3"
                :horizontal="true">
                <v-select v-model="selectedGroups" multiple :options="groupDDL" placeholder="Selecionar grupos" label="text"></v-select>
              </b-form-group>
               
              <div class="text-right">
                  <b-button variant="github" class="mr-1 btn-brand" @click="addGroup(selectedItem.id)"><i class="fa fa-check"></i><span>Incluir Grupos</span></b-button>  
               </div>

               <p></p>

               <b-table :items="groupItems" :fields="groupFields" :select-mode="groupSelectMode" responsive="sm" :primary-key="primaryKey" :tbody-transition-props="transProps" sort-icon-left
    
                    per-page="50" current-page="1" :busy="isBusyGroup" hover striped>
    
                      <template #table-busy>
      
                        <div class="text-center text-danger my-2">
      
                            <b-spinner class="align-middle"></b-spinner>
      
                            <strong>Carregando...</strong>
      
                        </div>
                      </template>
                                    
                      <!-- Example scoped slot for select state illustrative purposes -->
                      <template #cell(selected)="{ rowSelected }">
                          <template v-if="rowSelected">
                                            <span aria-hidden="true">&check;</span>
                                            <span class="sr-only">Selected</span>
                          </template>
                          <template v-else>
                            <span aria-hidden="true">&nbsp;</span>
                          
                            <span class="sr-only">Not selected</span>
                          </template>
                      </template>

                      <template v-slot:cell(action)="data">
                        <!--<c-switch class="" color="primary" :checked="data.item.st=='A'" label variant="pill" v-bind="switchLabelIcon" /> -->
                        <b-button size="sm" variant="danger" @click="deleteUserGroup(data.item.id, selectedItem.id)" class="mr-1 btn-brand"><i class="fa fa-close"></i></b-button>
                      </template>                                    
                                    
              </b-table>

          </b-card>
        </div>

        <div v-show="tabInfo == 'U'">

          <b-form @submit.stop.prevent="onSubmit">
    
          <div class="animated fadeIn">
        
            <b-card>
              <div slot="header">
                <strong>Dados do Usuário</strong>
              </div>

              <b-form-group
                description=""
                label="Id"
                label-for="id"
                :label-cols="3"
                :horizontal="true" v-show="selectedItem.id">
                <b-row>
                  <b-col cols="4">
                    <b-form-input  v-model="selectedItem.id" id="id" type="text" autocomplete="id" placeholder="Id" readonly></b-form-input>
                  </b-col>
                </b-row>
              </b-form-group>    
            
              <!-- 
              <b-form validated novalidate>
                <b-form-group label-for="inputError2" label="Usuário" label-cols="3"
                :horizontal="true">
                  <b-form-input type="text" v-model="selectedItem.username" class="form-control-warning" id="username" required></b-form-input>
                  <b-form-valid-feedback>
                    Nome de usuário válido
                  </b-form-valid-feedback>
                  <b-form-invalid-feedback>
                    Entre com o nome de usuário ou e-mail
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-form>
              --> 

              <b-form-group
                description=""
                label="Usuário"
                label-for="username"
                :label-cols="3"
                :horizontal="true">
                <b-form-input class="text-lowercase form-control-warning"  v-model="selectedItem.username" id="username" type="text" autocomplete="name" placeholder="Nome do usuário" required></b-form-input>
              </b-form-group>    

              <b-form-group
                description=""
                label="Senha"
                label-for="password"
                :label-cols="3"
                :horizontal="true" v-show="!selectedItem.id">
                <b-form-input  v-model="selectedItem.password" id="password" type="password" autocomplete="password" placeholder="Senha" required></b-form-input>
              </b-form-group>    

              <b-form-group
                description=""
                label="Confirmar senha"
                label-for="password2"
                :label-cols="3"
                :horizontal="true" v-show="!selectedItem.id">
                <b-form-input  v-model="selectedItem.password2" id="password2" type="password" autocomplete="password2" placeholder="Confirmar senha" required></b-form-input>
              </b-form-group>

            </b-card>

            <b-card>
              <div slot="header">
                <strong>Dados Pessoais</strong>
              </div>

            
              
              <b-form-group
              description=""
              label="Nome"
              label-for="fullname"
              :label-cols="3"
              :horizontal="true">
              <b-form-input class="text-uppercase" v-model="selectedItem.name" id="fullname" type="text" autocomplete="name" placeholder="Nome completo" required></b-form-input>
            </b-form-group>
            <b-form-group
              description=""
              label="Apelido"
              label-for="alias"
              :label-cols="3"
              :horizontal="true">
              <b-form-input class="text-uppercase" v-model="selectedItem.alias" id="alias" type="text" autocomplete="alias" placeholder="Apelido"></b-form-input>
            </b-form-group>
            <b-form-group
              label="Sexo"
              label-for=""
              :label-cols="3"
              :horizontal="true">
              <b-form-radio-group
                id="gender"
                name="gender">
                <div class="custom-control custom-radio custom-control-inline">
                  <input type="radio" id="gender1" name="gender" v-model="selectedItem.genderId" class="custom-control-input" value="1">
                  <label class="custom-control-label" for="gender1">Masculino</label>
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                  <input type="radio" id="gender2" name="gender" v-model="selectedItem.genderId" class="custom-control-input" value="2">
                  <label class="custom-control-label" for="gender2">Feminino</label>
                </div>
              </b-form-radio-group>
            </b-form-group>
          
            <b-form-group
              label="Data de nascimento"
              label-for="daten"
              :label-cols="3"
              :horizontal="true">
              <b-row>
                <b-col cols="6">
                  <b-form-input v-model="selectedItem.daten" type="date" id="daten"></b-form-input>
                </b-col>
              </b-row>
              
            </b-form-group>
            <b-form-group
              description="Por favor entre com seu e-mail"
              label="E-mail"
              label-for="email"
              :label-cols="3"
              :horizontal="true">
              <b-input-group>
                <div class="input-group-prepend">
                  <span class="input-group-text">
                    <i class='fa fa-envelope'></i>
                  </span>
                </div>
                <b-form-input v-model="selectedItem.email" id="email" type="email" placeholder="Entre com seu e-mail" autocomplete="email" required></b-form-input>
              </b-input-group>
            </b-form-group>

            <b-form-group label="Telefone" 
              description=""
              label-for="phone"
              :label-cols="3"
              :horizontal="true"
            >
            <b-input-group>
              <div class="input-group-prepend">
                <span class="input-group-text">
                  <i class='fa fa-phone'></i>
                </span>
              </div>
              <b-row cols="6">
                <b-col>      
                  <masked-input
                    type="tel"
                    name="phone"
                    class="form-control"
                    v-model="selectedItem.phone"
                    :mask="selectedItem.phone && selectedItem.phone.length > 14 ? ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/] : ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/]"
                    :guide="false"               
                    >
                  </masked-input>
                </b-col>
              </b-row>
            </b-input-group>
              
                          
            </b-form-group>

            <b-form-group label="Ramal"             
              description=""
              label-for="phoneext"
              :label-cols="3"
              :horizontal="true"
            >
              <b-input-group>
                <div class="input-group-prepend">
                  <span class="input-group-text">
                    <i class='fa fa-headphones'></i>
                  </span>
                </div>
                <b-row cols="6">
                  <b-col>      
                    <masked-input
                      type="tel"
                      name="phoneext"
                      class="form-control"
                      v-model="selectedItem.phoneext"
                      :mask="[/[1-9]/, /[1-9]/, /[1-9]/, /[1-9]/, /[1-9]/]"
                      :guide="false"     
                      
                      >
                    </masked-input>
                  </b-col>
                </b-row>
              </b-input-group>

            </b-form-group>

          

            </b-card>

            <b-card>
              <div slot="header">
                <strong>Empresa</strong>
              </div>

              <!--
              <b-form-group
                description=""
                label="Cargo"
                label-for="jobname"
                :label-cols="3"
                :horizontal="true">
                <b-form-input v-model="selectedItem.jobname" id="jobname" type="text" placeholder="Entre com seu cargo"></b-form-input>
              </b-form-group>
-->

      

              <b-form-group
                label="Departamento"
                label-for="department"
                :label-cols="3"
                :horizontal="true">
                <b-form-select id="department"
                  v-model="selectedItem.departmentId"
                  :plain="true"
                  :options="selectDepartmentDDL"
                  >
                </b-form-select>
              </b-form-group>

              <b-form-group
                description=""
                label="Cargo/Função"
                label-for="jobPosition"
                :label-cols="3"
                :horizontal="true">
                <b-form-select id="jobPosition"
                  v-model="selectedItem.jobPositionId"
                  :plain="true"
                  :options="selectJobPositionDDL"
                  >
                </b-form-select>
              </b-form-group>

              <b-form-group label="Assinatura" 
                description=""
                label-for="signature"
                >
                  <div slot="header">
                    Assinatura
                    <div class="card-header-actions">
                      <a href="https://github.com/surmon-china/vue-quill-editor" rel="noreferrer noopener" target="_blank" class="card-header-action">
                        <small class="text-muted">?</small>
                      </a>
                    </div>
                  </div>
                  <quill-editor v-model="selectedItem.signature" :content="selectedItem.signature" :options="editorMessageOptions" style="height: '200px'"></quill-editor>
              </b-form-group>
            </b-card>
        

            <b-input-group class="mb-4">
                <div class="text-danger" v-if="this.errorMessage && this.errorMessage != ''"><i class="fa fa-exclamation-triangle fa-lg mt-4"></i> {{ this.errorMessage }}</div>
            </b-input-group>
          
            <div slot="footer" class="text-right">
              <!--
              <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="enableDisable()" v-show="this.selectedItem.id && this.selectedItem.st=='I'"><i class="fa fa-toggle-on"></i><span>Habilitar</span></b-button>
              <b-button variant="html5" class="mr-1 btn-brand" @click="enableDisable()" v-show="this.selectedItem.id && this.selectedItem.st=='A'"><i class="fa fa-toggle-on"></i><span>Desabilitar</span></b-button>
              -->
              <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="closeEditModal()"><i class="fa fa-window-close"></i><span>Cancelar</span></b-button>
              <b-button variant="github" class="mr-1 btn-brand" @click="save()"><i class="fa fa-check"></i><span>Salvar Usuário</span></b-button>
            
            </div>
                  
          </div>
          </b-form>
        </div>
  
      </b-modal>
  
    </div>
  
  </template>
  
  <script>
  import Vue from 'vue'
  import axios from "axios";

  import { Switch as cSwitch } from '@coreui/vue'
  
  import Multiselect from 'vue-multiselect'
  import vSelect from 'vue-select'

  import VueQuillEditor from 'vue-quill-editor'

// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

Vue.use(VueQuillEditor)

//import { table } from 'console'
  import MaskedInput from 'vue-text-mask'

  /* Toast */
  import VueNotifications from 'vue-notifications'
  import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr
  
  const toastTypes = {
    success: 'success',
    error: 'error',
    info: 'info',
    warn: 'warn'
  }
  
  miniToastr.init({types: toastTypes})
  
  function toast ({title, message, type, timeout, cb}) {
    return miniToastr[type](message, title, timeout, cb)
  }
  
  const options = {
    success: toast,
    error: toast,
    info: toast,
    warn: toast
  }
  VueNotifications.setPluginOptions(options)
  
  Vue.use(VueNotifications, options)
  /* Toast - End */
  
  const newItem = {id: null, st: 'A', username: '', name: '', alias: '', email: '', password: '', password2: '', description: '', st: 'A', _rowVariant: '', signature: '', phonepublic: true, phoneextpublic: true}
  const newBatchItem = {
          items: [],
          status: 0,
          groupAction: 1,
          groups: [],
          password: '',
          password2: '',
        }

  export default {
    name: 'tables',
    components: {
      Event,
      cSwitch,
      MaskedInput,
      VueQuillEditor,
      Multiselect,
      vSelect
    },
    data: () => {
      return {
        batchGroups: [],
        batchItem: newBatchItem,
        filterJosPositionDDL: [],
        jobPositionDDL: [],

        // Tabela de acessos
          // Tabela Empresas
        isBusyGroup: false,
        groupItems: [],
        groupFields: [
          { key: 'name', label: 'Grupo de Acesso', sortable: true },
          { key: 'action', label: '', sortable: false, thStyle: { width: "40px" } }
        ],
        groupSelectMode: 'single',


        tabInfo: 'U',
        selectedGroups: null,
        batchGroups: null,
        groupDDL: [],
        companyDDL: [],
        // Tela de Alteração de Senha
        changePasswordUser: null,
        changePasswordErrorMessage: '',
        passwordModal: false,
        password: '',
        password2: '',
        currentPassword: '',

        editorMessageOptions: {
              placeholder: 'Entre com sua mensagem',
              readonly: false
            },
        isBusy: false,
        isLoadingMore: false,
        currentPage: 1,
        switchLabelIcon: {
            dataOn: '\u2713',
            dataOff: '\u2715'
        },
        switchLabelTxt: {
            dataOn: 'yes',
            dataOff: 'no'
        },

        tableRef: "table",
        tableSelectable: false,
        batchErrorMessage: '',
        errorMessage: '',
        editModal: false,
        dangerModal: false,
        filters: {
          key: '',
          status: 'A',
          jobPositionId: 0,
          departmentId: 0,
          companyId: 0,
          groupId: 0
        },

        modes: ['multi', 'single', 'range'],
        selectMode: 'multi',
        selected: [],
        transProps: {
          // Transition name
          name: 'flip-list'
        },
        primaryKey: "id",
        currentItem: null,
        selectedItem: newItem,
        items: [          
        ],
        groupActionDDL: [
          {
            value: 1,
            text: 'Incluir Grupos'
          },
          {
            value: 2,
            text: 'Excluir Grupos'
          }
        ],
        batchStatusDDL: [
          {
            text: '- Selecionar Status -',
            value: 0
          },
          {
            text: 'Ativo',
            value: 'A'
          },
          {
            text: 'Inativo',
            value: 'I'
          }
        ],
        statusddl: [
          {
            text: '- Todos -',
            value: 0
          },
          {
            text: 'Ativo',
            value: 'A'
          },
          {
            text: 'Inativo',
            value: 'I'
          }
        ],
        departmentDDL: [],
        fields: [
          {key: 'show_details', label: "", thStyle: { width: "50px" }, tdClass: 'align-middle' },
          {key: 'avatar', label: "", thStyle: { width: "60px" }, tdClass: 'align-middle' },
          //{key: 'id', label: 'Id', sortable: true, thStyle: { width: "15px" }, tdClass: 'align-middle' },
          {key: 'name', label: 'Usuário', sortable: true, tdClass: 'align-middle' },
          {key: 'phone', label: 'Telefone', sortable: true, thStyle: { width: "150px" }, tdClass: 'align-middle' },
          {key: 'phoneext', label: 'Ramal', sortable: true, thStyle: { width: "100px" }, tdClass: 'align-middle' },
          {key: 'st', label: 'Status', sortable: true, thStyle: { width: "40px" }, tdClass: 'align-middle' },
          {key: 'password', label: '', sortable: false, thStyle: { width: "40px" }, tdClass: 'align-middle' }
        ],
        /*
        fields: [
            'show_details',
            { key: 'first_name', sortable: true }, 
            { key: 'last_name', sortable: true }
        ],
        items: [
          { isActive: true, age: 40, first_name: 'Dickerson', last_name: 'Macdonald' },
          { isActive: false, age: 21, first_name: 'Larsen', last_name: 'Shaw' },
          { isActive: false, age: 89, first_name: 'Geneva', last_name: 'Wilson', _showDetails: false },
          { isActive: true, age: 38, first_name: 'Jami', last_name: 'Carney' }
        ],
        */
        filterable: ['username'],
        sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
        perPage: 20
      }
    },
    computed: {

      totalRows: function () { return this.filteredItems.length },

      selectJobPositionDDL: function() {
        var list = [...this.jobPositionDDL]
        list = list.sort((a,b) => (a.text > b.text) ? 1 : -1)
        list.unshift({ value: '0' , text: '' })
        return list
      },

      selectDepartmentDDL: function() {
        var list = [...this.departmentDDL]
        list = list.sort((a,b) => (a.text > b.text) ? 1 : -1)
        list.unshift({ value: '0' , text: '' })
        return list
      },

      selectGroupDDL: function() {
        var list = [...this.groupDDL]
        list = list.sort((a,b) => (a.text > b.text) ? 1 : -1)
        list.unshift({ value: '0' , text: '- Todos -' })
        list.unshift({ value: '-1' , text: '- Sem grupo -' })
        return list
      },
     
      filteredItems() {
      
          return this.items.filter(item => {
            // Filtro de grupo
            let groupFilter = true;
            if (this.filters.groupId == -1) {
              // Sem grupo - usuários que não têm nenhum grupo
              groupFilter = !item.groups || item.groups.length === 0;
            } else if (this.filters.groupId > 0) {
              // Grupo específico - usuários que pertencem a esse grupo
              groupFilter = item.groups && item.groups.some(g => g.id == this.filters.groupId);
            }
            // filters.groupId == 0 - todos os grupos (não filtra)
            
            return (this.filters.key == '' || (
                this.$utils.filterString(item.name, this.filters.key)
                || item.username == this.filters.key
                //(item.name != null && item.name.toLowerCase().indexOf(this.filters.key.toLowerCase()) > -1)
                //|| (item.username != null && item.username.toLowerCase().indexOf(this.filters.key.toLowerCase()) > -1)
                //|| (item.email != null && item.email.toLowerCase().indexOf(this.filters.key.toLowerCase()) > -1)
                ))
                && (this.filters.status==0 || (this.filters.status == 'A' || this.filters.status == 'I') && item.st == this.filters.status )
                && (this.filters.departmentId==0 || (this.filters.departmentId == item.departmentId))
                && (this.filters.jobPositionId==0 || (this.filters.jobPositionId == item.jobPositionId))
                && groupFilter
          })
        
      }
    },
    watch: {
      filteredItems() {
        var totalPages = Math.ceil(this.filteredItems.length / this.perPage) || 1;
        if (this.currentPage > totalPages) {
          this.currentPage = 1;
        }
      },
      perPage() {
        var totalPages = Math.ceil(this.filteredItems.length / this.perPage) || 1;
        if (this.currentPage > totalPages) {
          this.currentPage = 1;
        }
      }
    },
    methods: {

      hasCustomAvatar(avatar) {
        return !!avatar && avatar !== 'img/noimage.png';
      },
      avatarInitial(name) {
        return ((name || '').trim().charAt(0) || '?').toUpperCase();
      },

      async changePasswordSubmit() {
        var s = this;
        var userData;

        /*
        changePasswordUser: null,
        changePasswordErrorMessage: '',
        passwordModal: false,
        password: '',
        password2: '',
        currentPassword: '',
        */
       
        userData = {
            "id": this.changePasswordUser.id,
            "newPassword": this.password, 
            "userPassword": this.currentPassword,
            "uid": this.$store.state.currentUser.id ,
            "sid": this.$store.state.currentUser.sid
        };
        
        await axios.post(
            this.$store.state.ws_url + "/user/changepassword",
            userData
        ).then(
          function(resp) {
            //s.currentItem.st = currentUser.st == "A" ? "I" : "A" ;
            //s.closeEditModal()
            s.changePasswordErrorMessage = ''

            toast ({
              type: VueNotifications.types.warn,
              title: 'Usuário',
              message: 'Senha alterada com sucesso',
              timeout: 5000
            })

            s.passwordModal = false
          }
        ).catch(function (error) {
          console.log(error)
          toast ({
            type: VueNotifications.types.error,
            title: 'Usuário',
            message: error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Sem permissão de acesso.',
            timeout: 5000
          })
          
        });

      },

      changePassword() {

        if(this.currentPassword == '' || this.password == '' || this.password2 == '') {
          this.changePasswordErrorMessage = 'Preencha os campos obrigatórios.'
        }
        else
        if(this.password != this.password2) {
          this.changePasswordErrorMessage = 'Nova senha e Confirmar senha diferentes. Por favor verifique e tente novamente.'
        }
        else
        if(this.password.length < 3) {
          this.changePasswordErrorMessage = "Nova senha "
        }
        else {
          this.changePasswordErrorMessage = "Enviando solicitação. Aguarde..."
          this.changePasswordSubmit();
        }
      },

      changePasswordModal(item) {
        this.changePasswordUser = item
        this.password = ''
        this.password2 = ''
        this.currentPassword = ''
        this.passwordModal = true;

      },

      async changeBatchData() {
        var s = this;
        this.batchItem.uid = this.$store.state.currentUser.id
        this.batchItem.sid = this.$store.state.currentUser.sid
       
        await axios.post(
            this.$store.state.ws_url + "/user/batch",
            s.batchItem
        ).then(
          function(resp) {
            s.batchErrorMessage = ''
            toast ({
              type: VueNotifications.types.info,
              title: 'Alteração dos Usuários Selecionados',
              message: 'Dados alterados com sucesso',
              timeout: 5000
            })
            s.dangerModal = false
            s.refreshData()
          }
        ).catch(function (error) {
          s.batchErrorMessage = error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Sem permissão de acesso.'
          toast ({
            type: VueNotifications.types.error,
            title: 'Alteração dos Usuários Selecionados',
            message: error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Sem permissão de acesso.',
            timeout: 5000
          })
          
        });

      },

      changeBatch() {
        if((this.batchGroups && this.batchGroups.length > 0) || (this.batchItem.status && this.batchItem.status != '0') || (this.batchItem.password && this.batchItem.password.length > 0)  ) {
          if(this.batchItem.password && this.batchItem.password != '' && this.batchItem.password != this.batchItem.password2) {
              this.batchErrorMessage = 'Senhas e Confirmar senha diferentes, verifique e tente novamente.'            
          }
          else {
            this.batchErrorMessage = "Processando aguarde..."
            this.batchItem.items = this.selected.map(obj => obj.id);
            if(this.batchGroups)
              this.batchItem.groups = this.batchGroups.map(obj => Number(obj.value));
            this.changeBatchData()            
            
          }
        }
        else {
          this.batchErrorMessage = "Nenhuma alteração selecionada. Verifique e tente novamente."
        }
        
        
      },
      openBatchModal: function() {

        if(this.selected.length > 0) {
          this.batchItem = newBatchItem
          this.batchErrorMessage = ''
          this.dangerModal = true
        }
        else {
          toast ({
              type: VueNotifications.types.error,
              title: 'Alterar Selecionados',
              message: 'Nenhum usuário selecionado',
              timeout: 5000
            })
        }

        
      }, 
      submit() {
      },
      changeStatusClick(item) {
        if(item != null) {
          if(item.st == 'A') 
            item.st = 'I'; 
          else 
            item.st = 'A';

          this.saveItem(item);
        }
      },

      async saveItem(currentItem) {

        var s = this;
        var isNewUser = !currentItem.id;
        var postData = {...currentItem};

        postData["companyId"] = s.filters.companyId
        postData["uid"] = this.$store.state.currentUser.id ,
        postData["sid"] = this.$store.state.currentUser.sid

        await axios.post(
            this.$store.state.ws_url + "/user",
            postData
        ).then(function(resp) {
            // Mantém a janela aberta para permitir vincular grupos de acesso e
            // demais informações, em vez de fechar logo após incluir/alterar.
            if(isNewUser && resp.data.obj) {
              s.selectedItem.id = resp.data.obj
              s.tabInfo = 'G'
              s.getGroupByUser(s.selectedItem.id)
            }

            toast ({
              type: VueNotifications.types.success,
              title: 'Usuário',
              message: isNewUser ? 'Usuário criado. Inclua os grupos de acesso e demais informações.' : 'Usuário alterado com sucesso.',
              timeout: 5000
            })

            s.refreshData();
          }
        ).catch(function (error) {
          console.log("Erro:")
          console.log(error);
          toast ({
            type: VueNotifications.types.warn,
            title: 'Usuário',
            message: error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Sem permissão de acesso.',
            timeout: 5000
          })

        });

      },

      save() {
        
        let msgError = [];

        if(this.selectedItem.username.length < 2)
          msgError.push("Nome do usuário");
        if(this.selectedItem.name.length <= 3)
          msgError.push("Nome completo (mínimo 3 caracteres)");
        //if(this.selectedItem.email.length <= 3)
        //  msgError.push("E-mail");

        // Alteração
        if(this.selectedItem != null && this.selectedItem.id > 0) {
          
        }
        // Inclusão
        else {
          if(this.selectedItem.password.length <= 3)
            msgError.push("Senha (mínimo 3 caracteres)");
          if(msgError.length == 0) {
            if(this.selectedItem.password != this.selectedItem.password2)
               msgError.push("Senha e Confirmar senha diferentes. Verifique e tente novamente.");
          }
        }

        //console.log(msgError);
  
        if(msgError.length > 0) {
          let msgErrorExt = "Verifique os campos: ";
          let msgErrorSep = "";
          msgError.forEach(function(element) { msgErrorExt += msgErrorSep + element; msgErrorSep=", "; } )

          toast ({
            type: VueNotifications.types.error,
            title: 'Usuário',
            message: msgErrorExt,
            timeout: 5000
          })
        }
        else {
          this.saveItem(this.selectedItem);
        }
        
      },
      enableDisable() {
        //console.log('Habilitando/desabilitando usuário')
        this.changeStatus(this.selectedItem);
      },
      closeDangerModal() {
        this.dangerModal = false;
      },
      closeEditModal() {
        this.editModal = false;
      },
      openEditModal(item) {
        if(item == null) {
            this.selectedItem = { ...newItem };      
        }
        else {
            this.selectedItem = { ...item };
        }
        this.getGroupByUser(this.selectedItem.id)
        //console.log(this.selectedItem)
        this.selectedGroups = null
        this.tabInfo = 'U'
        this.editModal = true;
      },
      onRowSelected(items) {
        this.selected = items
        //console.log(items);
        //this.openEditModal(items[0])
      },

      async deleteUserGroup(groupId, userId) {
        var s = this;
        var currentUser = this.$store.state.currentUser
        
        await axios.delete(
            this.$store.state.ws_url + "/group/user?groupId=" + groupId + "&userId=" + userId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
        ).then(function() {
            s.getGroupByUser(userId)     
          }).catch(function (error) {
          toast ({
            type: VueNotifications.types.warn,
            title: 'Excluir Grupo do Usuário',
            message: error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Sem permissão de acesso.',
            timeout: 5000
          })
          
        });
        
      },

      async addUserGroups(currentItem, userId) {

        //console.log(currentItem);

        var s = this;
        
        //console.log('Salvando usuário')
        
        await axios.post(
            this.$store.state.ws_url + "/group/user",
            currentItem
        ).then(function() {
          s.getGroupByUser(userId)    
            
          }
        ).catch(function (error) {
          toast ({
            type: VueNotifications.types.warn,
            title: 'Inclusão de Grupo ao Usuário',
            message: error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Sem permissão de acesso.',
            timeout: 5000
          })
          
        });
        
      },

      addGroup(userId) {
          
        if(this.selectedGroups && this.selectedGroups.length > 0) {
          var groupArray = []
          var currentUser = this.$store.state.currentUser
          this.selectedGroups.forEach(function(item) {
            groupArray.push( { groupId: item.value, userId: userId, uid: currentUser.id, sid: currentUser.sid  } )
          })
          this.addUserGroups(groupArray, userId)
        }
        else {
          toast ({
                    type: VueNotifications.types.error,
                    title: 'Grupos',
                    message: 'Nenhum grupo selecionado',
                    timeout: 3000
                })
        }
      },
      selectAllRows() {
        this.$refs.selectableTable.selectAllRows();
      },
      clearSelectedRows() {
        this.$refs.selectableTable.clearSelected();
      },
      rowClicked(item) {
        this.currentItem = item
        //  //console.log(item);
            
        if(!this.tableSelectable) {
            this.clearSelectedRows();
           
            this.openEditModal(item);
        }
      },
      getBadge (status) {
        return status === 'A' ? 'primary'
            : status === 'I' ? 'danger'
            : status === 'Pending' ? 'warning'
                : status === 'Banned' ? 'danger' : 'primary'
      },
      toggleBusy() {
        this.isBusy = !this.isBusy
      },
       filterChanged() {
          if(this.filters.key && this.filters.key.length >= 4)
            this.refreshData();
        },
      async getDepartment() {
        var s = this;
        var currentUser = this.$store.state.currentUser;
        await axios.get(
            this.$store.state.ws_url + "/department/ddl?companyId=" + s.filters.companyId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
            
        ).then(function(resp) {
          s.departmentDDL = resp.data.obj;
        }).catch(function (error) {
          console.log(error);
        });
        
      },

      async getJobPosition() {
        var s = this;
        var currentUser = this.$store.state.currentUser

        await axios.get(
            this.$store.state.ws_url + "/jobposition/ddl?companyId=" + s.filters.companyId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
        ).then(function(resp) {
          s.jobPositionDDL = resp.data.obj;
        })
        .catch(function (error) {
          console.log(error);
        });
        
      },

      async getGroupByUser(userId) {
        var s = this;
        var currentUser = this.$store.state.currentUser;
        await axios.get(
            this.$store.state.ws_url + "/group/user/list?userId=" + userId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
            
        ).then(function(resp) {
          s.groupItems = resp.data.obj;
        }).
        catch(function (error) {
          s.groupItems = []
        });
      },

      async getGroup() {
        var s = this;
        var currentUser = this.$store.state.currentUser;
        await axios.get(
            this.$store.state.ws_url + "/group/ddl?uid=" + currentUser.id + "&sid=" + currentUser.sid
            
        ).then(function(resp) {
          s.groupDDL = resp.data.obj;
        }).
        catch(function (error) {
          console.log(error);
        });
      },

      async refreshData() {
         this.isBusy = true;
         this.isLoadingMore = false;
     
          var s = this;
          var currentUser = this.$store.state.currentUser;
          var page = 1;
          var pageSize = 100;
          var allItems = [];
          var hasMoreData = true;

          while (hasMoreData) {
            //var url = this.$store.state.ws_url + "/user?companyId=" + s.filters.companyId + "&groupId=" + s.filters.groupId + "&key=" + s.filters.key + "&uid=" + currentUser.id + "&sid=" + currentUser.sid + "&page=" + page + "&pageSize=" + pageSize;

            var url = this.$store.state.ws_url + "/user?companyId=" + s.filters.companyId + "&key=" + s.filters.key + "&uid=" + currentUser.id + "&sid=" + currentUser.sid + "&page=" + page + "&pageSize=" + pageSize;
            try {
              var resp = await axios.get(url);
              
              if (resp.data.obj && resp.data.obj.length > 0) {
                allItems = allItems.concat(resp.data.obj);
                
                // Atualiza a tabela com os dados carregados até o momento
                s.items = [...allItems];
                
                // Remove o loading após carregar a primeira página
                if (page === 1) {
                  s.isBusy = false;
                  // Se há mais páginas, mostra o spinner de loading adicional
                  if (resp.data.obj.length === pageSize) {
                    s.isLoadingMore = true;
                  }
                }
                
                // Se retornou menos itens que o pageSize, não há mais páginas
                if (resp.data.obj.length < pageSize) {
                  hasMoreData = false;
                } else {
                  page++;
                }
              } else {
                // Sem mais dados
                hasMoreData = false;
              }
            } catch (error) {
              hasMoreData = false;
              toast({
                type: VueNotifications.types.error,
                title: 'Usuário',
                message: 'Sem permissão de acesso. Verifique e tente novamente.',
                timeout: 3000
              });
            }
          }

          console.log("Total de usuários carregados: " + allItems.length);

          /*
          if(resp && resp.data && resp.data.code && resp.data.code > 0) {
            //this.items = resp.data.obj;
            this.items = this.$utils.mergeArrays(this.items, resp.data.obj, 'id');
          }
          */
          this.isBusy = false;
          this.isLoadingMore = false;               
        
      },
      changeCompany() {
        this.getJobPosition();
        this.getDepartment();
        this.getGroup();
        this.refreshData();
      }
    },
    mounted: function() {
      this.companyDDL = this.$store.state.currentUser.companies
      this.filters.companyId = this.$store.state.currentUser.companyId
      this.changeCompany();
      //console.log(this.$store.state.currentUser)
    }
  }
  </script>
  
<style scoped>

table#table-transition-example .flip-list-move {
  transition: transform 1s;
}

.circle-img {
  width: 38px;
  height: 38px;
  object-fit: cover;
  overflow: hidden;
}

.avatar-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  background-color: #20a8d8;
  color: #fff;
  font-size: 1rem;
  font-weight: 500;
  user-select: none;
}

.ql-editor{
    min-height:200px;
}

</style>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

